import React from "react";
import { LayoutContainer as SharedLayout } from "src/styled/shared.styled";

import styles from "./addReport.module.scss";

export const AddReportContainer: React.FC<
  React.HTMLAttributes<HTMLDivElement>
> = ({ children, className, ...rest }) => (
  <div className={`${styles.addReportContainer} ${className ?? ""}`} {...rest}>
    {children}
  </div>
);

export const LayoutReportContainer: React.FC<
  React.HTMLAttributes<HTMLDivElement>
> = ({ children, className, ...rest }) => (
  <SharedLayout
    className={`${styles.layoutReportContainer} ${className ?? ""}`}
    {...rest}>
    {children}
  </SharedLayout>
);

export const ReportFormWrapper: React.FC<
  React.HTMLAttributes<HTMLDivElement>
> = ({ children, className, ...rest }) => (
  <div className={`${styles.reportFormWrapper} ${className ?? ""}`} {...rest}>
    {children}
  </div>
);

export const FullWHContainer: React.FC<
  React.HTMLAttributes<HTMLDivElement>
> = ({ children, className, ...rest }) => (
  <div className={`${styles.fullWHContainer} ${className ?? ""}`} {...rest}>
    {children}
  </div>
);

export const LogbooksInformations: React.FC<
  React.HTMLAttributes<HTMLDivElement>
> = ({ children, className, ...rest }) => (
  <div
    className={`${styles.logbooksInformations} ${className ?? ""}`}
    {...rest}>
    {children}
  </div>
);
